const content = {
  component: "PageTypeA",
  cssClass: "page-four",
  meta: {
    title: "Cloud is the silver lining for bees",
    description:
      "Researchers are using AI to save the lives of bees and maintain the balance between nature and humans.",
    og: {
      type: "website",
      title: "AI is saving bees—discover how",
      description: `Bees are vital for our survival, yet they are dying at an alarming rate. By analysing acoustic data collected from listening to their wings and feet, AI is able to predict when they will swarm—enabling humans to intervene if it’s the wrong time of year.`,
      image: require("../../assets/images/social/silver-lining-1200x630.jpg")
    },
    twitter: {
      card: "summary",
      title: "Discover how AI is saving the lives of bees",
      description: `Without bees, humans can't survive. That’s why The World Bee Project is using AI to predict their behaviour and stop them swarming during times of year that could be dangerous.`,
      site: "@Oracle",
      creator: "@Oracle",
      image: require("../../assets/images/social/silver-lining-300x300.jpg")
    }
  },
  title: "<span>Cloud is the Silver </span><span>Lining for Bees</span>",
  heroImage: {
    preload: require("../../assets/images/bgs/silver-lining-pre.jpg"),
    loaded: require("../../assets/images/bgs/silver-lining.jpg"),
    mobile: require("../../assets/images/bgs/silver-lining-mobile.jpg")
  },
  // * the heroImageOptions are currently only required and supported when using the PageTypeA component
  heroImageOptions: {
    default: {
      customPosition: [true, "center -10px"]
    },
    mobile: {
      customPosition: [false]
    },
    limtedHeight: {
      customPosition: [false]
    }
  },
  sections: [
    {
      component: "SectionCopy",
      content: {
        copy: `
          Sabiha Rumani Malik, founder and President of the World Bee Project CIC – the global start-up community interest company is aiming to protect bees and pollinators numbers from declining livelihoods. The organisation’s initiatives are cutting-edge. The latest utilises the power of the Cloud and an international network of remotely monitored smart bee hives in what Malik describes as “an extraordinary marriage between nature and technology”.
        `,
        type: "intro"
      }
    },
    {
      component: "SectionSeperator",
      content: {
        image: null
      }
    },
    {
      component: "SectionCopy",
      content: {
        copy: `
          <p>“Data from around the globe shows that honey bees are the world’s most important single species of pollinator in natural ecosystems and a key contributor to natural ecosystem functions”, says Sabiha.</p>
          <p>From California to India’s northern state of Uttarakhand, you will find conversation projects linking bees and pollinators to food security, livelihoods and social inclusion backed by Sabiha Rumani Malik. With good reason:</p>
        `,
        type: "default"
      }
    },
    {
      component: "SectionQuote",
      content: {
        quote: `Bees pollinate. We are entirely dependent on pollinators for the food we eat” says Malik, “their declining numbers pose a severe threat to global food security. We have to come up with innovative solutions to ensure bees are here to pollinate the food crops we need to feed our future generations.`,
        author: `Sabiha Rumani Malik`,
        position: `Founder, The World Bee Project`,
        type: "quote"
      }
    },
    {
      component: "SectionCopy",
      content: {
        copy: `
          <p>To do this, Malik has founded The World Bee Project with the ambitious aim of creating ‘a sustainable relationship between pollination, food security, biodiversity, and human wellbeing’. Key to achieving this, says Malik, are “partnerships and collaboration on a global scale”.</p>
          <p>Fittingly, The World Bee Project has partners around the world – from India’s agricultural powerhouse, the G.B. Pant University of Agriculture and Technology, also known as Pantnagar University,  and the  Himalayan Farmlands Initiative to the Faculty of Agricultural and Food Sciences at Széchenyi István University in Hungary.</p>
        `,
        type: "default"
      }
    },
    {
      component: "SectionSeperator",
      content: {
        image: require("../../assets/images/svgs/iot.svg")
      }
    },
    {
      component: "SectionCopy",
      content: {
        copy: `
          <p>Its most significant partnership in Europe is with the School of Agriculture, Policy and Development at the University of Reading, one of the top 10 agriculture schools in the world. The partnership’s most ambitious, advanced and potentially impactful initiative aims to work with smallholder farmers to implement ecological intensification and pollinator restoration.</p>
          <p>For this and similar projects ‘The World Bee Project Hive Network’ programme hopes to generate invaluable insights collected from an international network of smart bee hives. Begun in September 2018, the network gathers data from internet-connected sensors made by Arnia. As much as 2 terabytes can be generated every day by measuring conditions like temperature, humidity and honey yield. </p>
          <p>This allows researchers to use intricate acoustic data captured in the hive, including the movement of bees’ wings and feet to ‘listen’ to the hives to predict various different states of the colony throughout the year, for example if a colony is preparing to swarm at the wrong time of year.  </p>
          <p>To both deal with the quantities of data generated and gain entirely new insights from this unique source, The World Bee Project is making use of Oracle Cloud’s AI, data visualisations and analytics.</p>
        `,
        type: "default"
      }
    },
    {
      component: "SectionQuote",
      content: {
        quote: `Our partnership with Oracle Cloud is an extraordinary marriage between nature and technology. It will enable advanced research and, crucially, action on a previously impossible scale.`,
        author: `Sabiha Rumani Malik`,
        position: `Founder, The World Bee Project`,
        type: "quote"
      }
    },
    {
      component: "SectionCopy",
      content: {
        copy: `
          <p>Significantly, this data is being made available to researchers and organisations around the world with an interest in pollination, food security and biodiversity.</p>
          <p>“By sharing this data with peers, we can multiply the impact of our work” says Professor Simon Potts, The World Bee Project co-founder and a world-leader in this field.</p>
        `,
        type: "default"
      }
    },
    {
      component: "SectionQuote",
      content: {
        quote: `From academic research that changes agricultural practices, to education programmes that inspire children, making this huge data resource easily available can be as important as the work undertaken to collect it.`,
        author: `Professor Simon Potts`,
        position: `Co-Founder, The World Bee Project`,
        type: "quote"
      }
    },
    {
      component: "SectionCopy",
      content: {
        copy: `
          The World Bee Project Hive Network brings the ancient practice of bee keeping in to the 21st century, building knowledge, fostering collaboration and enabling action. For bees, this time the Cloud is the silver lining.
        `,
        type: "default"
      }
    },
    {
      component: "SectionCallToAction",
      content: {
        title: `Transform your business with Oracle`,
        ctas: [
          {
            image: require("../../assets/images/svgs/report.svg"),
            copy: "Decision makers and technology report",
            url:
              "https://www.oracle.com/uk/area-of-interest/it/leading-technologies-survey.html?source=:ow:o:cs:mt:RC_EMMK181024P00070C0001:YTTFY19_IT_AW_HI_CM_UK_C33_Q33_RT&intcmp=:ow:o:cs:mt:RC_EMMK181024P00070C0001:YTTFY19_IT_AW_HI_CM_UK_C33_Q33_RT",
            buttonCopy: "Read report "
          }
        ],
        type: "cta"
      }
    }
  ]
};

export default content;
